import { GarantieModel } from "src/app/core/models/garantie-model";
import { ParticulierFaciliteItem } from "./particulier-facilite-item";
import { Employeur } from "src/app/parametrage/core/model/employeur";

export class CreateDossierParticulier {
  categorie: String;
  customerCode: String;
  customerNumber: String;
  dateReceptionDossier: String;
  firstname: String;
  lastname: String;
  fonction: String;
  email: String;
  matricule: String;
  situationMatrimoniale: String;
  adressePostale: String;
  adresseGeographique: String;
  homePhone: String;
  mobilePhone: String;
  workPhone: String;
  employeurName: String;
  employeurAdresse: String;
  dateEmbauche: String;
  ancienneteEmploi: number;
  profession: String;
  fonctionDansEntreprise: String;
  salaireEmprunteur: number;
  salaireConjoint: number;
  montantLoyer: number;
  montantAutreRevenu: number;
  totalEngagementActuel: number;
  chargeEmpruntSollicite: number;
  typePiece: String;
  dateExpPiece: String;
  dateNaissance: String;
  lieuNaissance: String;
  codeAgenceDomiciliation: String;
  codeGestionnaireDomiciliation: String;
  libelleAgenceDomiciliation: String;
  rib: String;
  numeroCompte: String;
  employeur: Employeur;
  montantBonusDat: number;
  primeTrimestrielle: number;
  domiciliationSalaire: boolean;
  particulierFaciliteItem: ParticulierFaciliteItem;
  garanties: GarantieModel[];
  requestIdParent : String;
}
